import { ReferralType } from '~/types/referral';
import type { SpecialtyFormConfig } from '~/types/specialty';
import { DentalSpecialty } from '~/types/specialty';

/**
 * Configuration for TMJ specialty referral form
 */
export const tmjConfig: SpecialtyFormConfig = {
  specialty: DentalSpecialty.TMJ,
  displayName: 'TMJ',
  requiresToothSelection: false,
  referralTypes: [
    ReferralType.URGENT,
    ReferralType.ROUTINE,
    ReferralType.SYMPTOMATIC,
    ReferralType.ELECTIVE,
    ReferralType.CONSULTATION,
  ],
  diagnosisOptions: [],
};
